import React from 'react';

const AccessRestricted = ({
  title = 'Access Restricted',
  message = "You don't have permission to access this page.",
}) => {
  return (
    <div className="text-center py-4">
      <div className="noContentFound">
        <i className="uil uil-lock font-size-48 text-muted mb-3 d-block" />
        <h5 className="text-muted mb-2">{title}</h5>
        <p className="text-muted mb-0">{message}</p>
      </div>
    </div>
  );
};

export default AccessRestricted;
